import StandardCards from '../../data/packs/standard.yaml'
import SexAndRelationshipsCards from '../../data/packs/sex_and_relationships.yaml'

let allPacks = {};
allPacks[StandardCards.slug] = StandardCards;
allPacks[SexAndRelationshipsCards.slug] = SexAndRelationshipsCards;

export default class Deck {
  constructor(packs = ["standard"]) {
    this.cards = [];
    this.packs = packs;
    this.fill();
  }

  pluck() {
    if (this.cards.length <= 0) {
      this.fill();
    }
    console.log("Card plucked. " + (this.cards.length - 1) + " cards in deck.");
    return this.cards.pop();
  }

  fill() {
    this.cards = [];
    this.packs.forEach(pack => {
      if (pack in allPacks) {
        this.cards.push(...allPacks[pack].cards);
      }
    });
    this.shuffle();

    console.log("Deck filled. " + this.cards.length + " cards in deck.");
  }

  shuffle() {
    for (let i = this.cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
    }
  }
}
